import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import './LoadingOverlay.css';
import { CircularProgress } from '@material-ui/core';
import classNames from 'classnames';

const InlineOverlay = ({ size }) => (
  <div className="loading-overlay-inline">
    <div>
      <CircularProgress size={size} />
    </div>
  </div>
);

InlineOverlay.defaultProps = {
  size: 40,
};

InlineOverlay.propTypes = {
  size: PropTypes.number,
};

const styles = () => ({
  root: {},
});

const LoadingWrapper = (props) => {
  const {
    loading, children, className, classes, size, style: styleProp,
  } = props;
  return (
    <div
      style={{
        position: 'relative',
        height: '100%',
        ...styleProp,
      }}
      className={classNames(classes.root, className)}
    >
      {children}
      {loading && <InlineOverlay size={size} />}
    </div>
  );
};

LoadingWrapper.defaultProps = {
  className: '',
  style: {},
  size: 40,
};

LoadingWrapper.propTypes = {
  loading: PropTypes.bool.isRequired,
  children: PropTypes.any.isRequired,
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  style: PropTypes.object,
  size: PropTypes.number,
};

export default withStyles(styles)(LoadingWrapper);
